/**
 * 客户门户 API
 *
 * 使用场景：客户登录、客户门户的所有接口调用
 * 独立于内部员工 API 和客户档案管理 API，互不影响
 * 所有接口路径以 /customer 开头
 *
 * @author system
 * @date 2026-08-11
 */

import request from '@/utils/request'

/**
 * 客户门户登录
 *
 * @param {Object} data - { loginName: 手机号, password: 密码 }
 * @returns {Promise}
 */
export function customerPortalLogin(data) {
    return request({
        url: '/customer/login',
        method: 'post',
        data
    })
}

/**
 * 客户门户退出登录
 *
 * @returns {Promise}
 */
export function customerPortalLogout() {
    return request({
        url: '/customer/logout',
        method: 'post'
    })
}

/**
 * 获取客户门户用户信息
 *
 * @returns {Promise}
 */
export function getCustomerPortalInfo() {
    return request({
        url: '/customer/info',
        method: 'get'
    })
}

/**
 * 客户门户修改密码
 *
 * @param {Object} data - { oldPassword: 旧密码, newPassword: 新密码 }
 * @returns {Promise}
 */
export function customerPortalChangePassword(data) {
    return request({
        url: '/customer/changePassword',
        method: 'post',
        data
    })
}

// ==================== 客户订单/报告（新增） ====================

/**
 * 获取客户订单列表
 * 后端从 SecurityContext 获取当前登录客户信息，无需传 customerId
 *
 * @param {Object} params - { pageNum, pageSize }
 * @returns {Promise}
 */
export function getCustomerOrderList(params) {
    return request({
        url: '/customer/order/list',
        method: 'get',
        params
    })
}

/**
 * 获取客户报告列表
 * 后端从 SecurityContext 获取当前登录客户信息，无需传 customerId
 *
 * @param {Object} params - { pageNum, pageSize }
 * @returns {Promise}
 */
export function getCustomerReportList(params) {
    return request({
        url: '/customer/report/list',
        method: 'get',
        params
    })
}